module.exports = __webpack_public_path__ + "img/pdf_icon.4bddccb1.png";